import React from "react";
import { Switch } from "react-router-dom";

import ProtectedRoute from "./ProtectedRoute";
import HomePage from "../containers/HomePage";

export class RootRoute extends React.Component {
  render() {
    return (
      <Switch>
        <ProtectedRoute exact path="/" component={HomePage} />
        <ProtectedRoute exact path="/:city" component={HomePage} />
      </Switch>
    );
  }
}
